// extracted by mini-css-extract-plugin
export var animationContainer = "_j4-0";
export var asteriskIcon = "_j4-8";
export var conversationLeftSection = "_j4-4";
export var conversationListItem = "_j4-3";
export var conversationMiddleSection = "_j4-5";
export var conversationRightSection = "_j4-6";
export var detailsContent = "_j4-1";
export var listContainer = "_j4-7";
export var modalContent = "_j4-2";